/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListPersonNumberRequest
 */
export interface ListPersonNumberRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ListPersonNumberRequest
     */
    userIds: Array<string>;
}

export function ListPersonNumberRequestFromJSON(json: any): ListPersonNumberRequest {
    return ListPersonNumberRequestFromJSONTyped(json, false);
}

export function ListPersonNumberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPersonNumberRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIds': json['userIds'],
    };
}

export function ListPersonNumberRequestToJSON(value?: ListPersonNumberRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userIds': value.userIds,
    };
}


